import React, { useState, useEffect } from "react";
import { makeStyles, withWidth } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import DevicesList from "./DevicesListCumPositionMT";
import MainToolbar from "./MainToolbar";
import Map from "./googlemap/Map";
import SelectedDeviceMap from "./googlemap/SelectedDeviceMap";
import GeofenceMap from "./googlemap/GeofenceMap";
import CurrentPositionsMap from "./googlemap/CurrentPositionsMap";
import SinglePositionsMap from "./googlemap/SinglePositionsMap";
import TrafficLayerMap from "./googlemap/TrafficLayerMap";

import { useDispatch, useSelector } from "react-redux";
import ReplayPage from "./reports/ReplayPageMT";
import {
  mapStateTypesActions,
  devicesActions,
  positionsActions,
  userDeviceStateActions,
  showLoaderStateActions,
} from "./store";
import ClearIcon from "@material-ui/icons/Clear";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
// import TrafficIcon from '@material-ui/icons/Traffic';
import TrafficRoundedIcon from "@material-ui/icons/TrafficRounded";
import LayersIcon from "@material-ui/icons/Layers";
import AddToQueueIcon from "@material-ui/icons/AddToQueue";
import ReplayOutlined from "@material-ui/icons/ReplayOutlined";

// import ChartComp from "./PieChart";

const API_INTERVAL_VAL = 10000;
const MAX_DEVICE_COUNT = 50; // Interval threash hold limit

const mapLayerIntialState = {
  traffic: true,
  numberplate: true,
  geofence: true,
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flexGrow: 1,
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  drawerPaper: {
    position: "relative",
    boxShadow: "-1px 6px 4px 6px #b9bcdf",
    [theme.breakpoints.up("sm")]: {
      width: 500,
    },
    [theme.breakpoints.down("xs")]: {
      height: 250,
    },
  },
  mapContainer: {
    flexGrow: 1,
  },
  resetButton: {
    position: "absolute",
    right: "1%",
    top: "10%",
  },
  mapButtons: {
    position: "absolute",
    right: "1%",
    top: "10%",
    //backgroundColor: 'white',
  },
}));

const ResetButton = ({ onBtnClick }) => {
  return (
    <div>
      <Fab size="small" color="primary" aria-label="reset" onClick={onBtnClick}>
        <ClearIcon />
      </Fab>
    </div>
  );
};

const TrafficButton = ({ onBtnClick, mapLayerState }) => {
  const { traffic } = mapLayerState || {};
  return (
    <div style={{ margin: "5px" }}>
      <IconButton
        style={{ backgroundColor: "white", height: "45px", width: "45px" }}
        color={(traffic && "primary") || "secondary"}
        aria-label="add an alarm"
        onClick={() => onBtnClick("traffic")}
      >
        <TrafficRoundedIcon />
      </IconButton>
    </div>
  );
};

const GeofenceButton = ({ onBtnClick, mapLayerState }) => {
  const { geofence } = mapLayerState || {};
  return (
    <div style={{ margin: "5px" }}>
      <IconButton
        style={{ backgroundColor: "white", height: "45px", width: "45px" }}
        color={(geofence && "primary") || "secondary"}
        aria-label="add an alarm"
        onClick={() => onBtnClick("geofence")}
      >
        <LayersIcon />
      </IconButton>
    </div>
  );
};

const NumberPlateButton = ({ onBtnClick, mapLayerState }) => {
  const { numberplate } = mapLayerState || {};
  return (
    <div style={{ margin: "5px" }}>
      <IconButton
        style={{ backgroundColor: "white", height: "45px", width: "45px" }}
        color={(numberplate && "primary") || "secondary"}
        aria-label="add an alarm"
        onClick={() => onBtnClick("numberplate")}
      >
        <AddToQueueIcon />
      </IconButton>
    </div>
  );
};

const ReloadAllData = ({ onBtnClick }) => {
  return (
    <div style={{ margin: "5px" }}>
      <IconButton
        style={{ backgroundColor: "white", height: "45px", width: "45px" }}
        color={"secondary"}
        aria-label="add an alarm"
        onClick={() => onBtnClick()}
      >
        <ReplayOutlined />
      </IconButton>
    </div>
  );
};

const extractValidDevicesAndPositions = (data) => {
  const result = {
    devices: [],
    positions: [],
  };

  data.forEach((entry) => {
    const { device, position } = entry;
    if (device) {
      result.devices.push(device);
    }
    if (position) {
      result.positions.push(position);
    }
  });

  return result;
};

const MainPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [mapRef, setMapRef] = useState(null);
  const [mapCenter, setMapCenter] = React.useState(null);
  const [mapLayerState, setMapLayerState] = React.useState(mapLayerIntialState);
  const mapType = useSelector((state) => state.mapStateTypes.mapCompState);

  const positions = useSelector((state) =>
    Object.values(state.positions.items)
  );
  const [useBound, setUseBound] = useState(false);
  let user = useSelector((state) => state.session.user);
  const [isIntervalActive, setIsIntervalActive] = useState(true);
  const deviceList = useSelector((state) => Object.values(state.devices.items));
  const fetchData = async () => {
    try {
      !isIntervalActive && dispatch(showLoaderStateActions.addState(true));
      const response = await fetch(
        `/api/users/${user.id}/userDevicesState?pieChartOnly=false`
      );
      const dataRespone = await response.json();
      !isIntervalActive && dispatch(showLoaderStateActions.addState(false));
      const outputData = extractValidDevicesAndPositions(
        dataRespone.deviceCumPositionList
      );

      if (outputData.devices) {
        dispatch(devicesActions.update(outputData.devices));
      }
      if (outputData.positions) {
        dispatch(positionsActions.update(outputData.positions));
      }

      if (outputData.devices.length > MAX_DEVICE_COUNT) {
        setIsIntervalActive(false); // Disable interval fetching if data has 30 or more records
      } else {
        setIsIntervalActive(true);
      }
      dispatch(
        userDeviceStateActions.addState({
          ...dataRespone,
          deviceCumPositionList: [],
        })
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    if (isIntervalActive) {
      const interval = setInterval(() => {
        !document.hidden && fetchData();
      }, API_INTERVAL_VAL); // Fetch data every 10 seconds
      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [isIntervalActive]);

  useEffect(() => {
    const beforeUnloadHandler = (event) => {
      event.preventDefault();
      event.returnValue = "Use reload button on map";
      return "Use reload button on map";
    };
    window.addEventListener("beforeunload", beforeUnloadHandler);
    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, []);

  const handleReloadAllData = () => {
    fetchData();
  };

  const changeCenter = (center) => {
    setMapCenter(center);
  };
  const loadHandler = (map) => {
    setMapRef(map);
  };

  const renderChildMapComp = () => {
    let Element = null;
    switch (mapType) {
      case "HOME":
        Element = (
          <>
            <CurrentPositionsMap numberPlateState={mapLayerState.numberplate} />
            {mapLayerState.geofence && <GeofenceMap />}
            {mapLayerState.traffic && <TrafficLayerMap />}
            <div className={classes.mapButtons}>
              <TrafficButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
              <GeofenceButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
              <NumberPlateButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
              {deviceList?.length > MAX_DEVICE_COUNT && (
                <ReloadAllData onBtnClick={handleReloadAllData} />
              )}
            </div>
          </>
        );
        break;
      case "ROUTE_PLAY":
        Element = (
          <>
            <ReplayPage mapRef={mapRef} reSetMap={reSetMap} />
            {/* <SelectedDeviceMap onChangeCenter={changeCenter} /> */}
            {mapLayerState.geofence && <GeofenceMap />}
            <div className={classes.mapButtons}>
              <GeofenceButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
            </div>
          </>
        );
        break;
      case "Device_Selected":
        Element = (
          <>
            <SinglePositionsMap />
            <SelectedDeviceMap onChangeCenter={changeCenter} />
            {mapLayerState.geofence && <GeofenceMap />}
            {mapLayerState.traffic && <TrafficLayerMap />}
            <div className={classes.mapButtons}>
              <ResetButton onBtnClick={reSetMap} />
              <TrafficButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
              <GeofenceButton
                mapLayerState={mapLayerState}
                onBtnClick={changeMapLayerState}
              />
            </div>
          </>
        );
        break;
    }
    return Element;
  };
  const reSetMap = () => {
    changeCenter(null);
    dispatch(devicesActions.select(null));
    setUseBound(false);
    dispatch(mapStateTypesActions.addState("HOME"));
  };

  const changeMapLayerState = (key) => {
    const { [key]: value } = mapLayerState || {};
    const newState = { ...mapLayerState, [key]: !value };
    setMapLayerState(newState);
  };

  const fitBounds = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    positions.map((place) => {
      bounds.extend({ lat: place.latitude, lng: place.longitude });
      return place.id;
    });
    map.fitBounds(bounds);
  };

  useEffect(() => {
    if (mapRef && !useBound && positions.length > 0) {
      fitBounds(mapRef);
      setUseBound(true);
    }
  }, [positions]);

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <MainToolbar />

        <div className={classes.mapContainer}>
          <Map center={mapCenter} loadHandler={loadHandler}>
            {renderChildMapComp()}
          </Map>
        </div>

        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="right"
        >
          <DevicesList reSetMap={reSetMap} />
        </Drawer>
      </div>
    </div>
  );
};

export default withWidth()(MainPage);
